import useSWR from 'swr';

import { Currency } from '@zooplus/commons-lang';

export type CustomerLevelType = 'BASIC' | 'PREMIUM' | 'SP_MIGRATION';

export type CustomerLevelOverview = {
  customerId: number;
  siteId: number;
  status: string;
  levelKey: string;
  type: CustomerLevelType;
  savings: MembershipSavings;
  startDate: Date;
  endDate?: Date;
};

export type CustomerInfoWithLevel = {
  firstName: string | null;
  lastName: string | null;
  loyaltyLevel: CustomerLevelOverview;
};

export type CustomerBalance = {
  balanceActive: number;
  expiringBalance: number;
  expiryDate?: string;
};

export type MembershipSavings = {
  amount: number;
  currency: Currency;
};

export interface CustomerOverview {
  customerInfo: CustomerInfoWithLevel;
  customerBalance: CustomerBalance;
}

export function useCustomerOverview(shouldFetch: boolean = true) {
  return useSWR(
    shouldFetch ? '/protected/api/loyalty-management/memberships/customer/overview' : null,
    async (...args): Promise<CustomerOverview> => {
      const response = await fetch(...args);

      return await response.json();
    },
    {
      errorRetryInterval: 1000,
      errorRetryCount: 3,
      dedupingInterval: 5000,
      revalidateOnFocus: false,
    },
  );
}

export function getCustomerLevelType(customerLevel: CustomerLevelOverview) {
  if (customerLevel.status === 'DELETED' || customerLevel.status === 'CANCELLED') {
    return 'BASIC' as CustomerLevelType;
  }
  return customerLevel.type;
}

export function isPremiumOrMigratedCustomer(customerLevelType: CustomerLevelType) {
  return customerLevelType === 'PREMIUM' || customerLevelType === 'SP_MIGRATION';
}
